import React, { FC } from 'react'
import { Flex, Heading, Text } from '@moonpig/launchpad-components'
import { getDepartmentTitle } from '@moonpig/web-core-utils'
import { breakpointDown, styled } from '@moonpig/launchpad-utils'
import { AlternativeDepartmentResultsHeaders } from '../AlternativeDepartmentResultsHeaders/AlternativeDepartmentResultsHeaders'
import { capitaliseFirstCharacter } from '../../utils'
import { useFindLocaleText } from '../../text-localisation'
import type { SearchContext } from '../../store/slices/shared'
import { SearchTermHeaderText } from './SearchTermHeaderText'

const StyledHeader = styled(Flex)`
  flex-flow: column wrap;
  align-items: flex-start;
  line-height: 0.2;
`

const StyledRedirectionText = styled(Text)`
  padding-top: 16px;
  ${breakpointDown('md')} {
    padding-top: 8px;
  }
`

type Props = {
  totalCount: number
  searchContext: SearchContext
}

export const DepartmentHeaders: FC<Props> = ({ searchContext, totalCount }) => {
  const { redirectedDepartment } = searchContext

  const localiseText = useFindLocaleText()

  const redirectedDepartmentName = redirectedDepartment
    ? capitaliseFirstCharacter(getDepartmentTitle(redirectedDepartment))
    : ''

  return (
    <StyledHeader>
      <Heading level="h4" typography="typeBodyText" mr={4} mb={0}>
        <SearchTermHeaderText
          totalCount={totalCount}
          searchContext={searchContext}
        />
        <AlternativeDepartmentResultsHeaders searchContext={searchContext} />
      </Heading>
      {redirectedDepartmentName &&
        searchContext.redirectionSource === 'no_results' && (
          <StyledRedirectionText>
            {localiseText('find.no_results_for_department', {
              departmentName: redirectedDepartmentName,
            })}
          </StyledRedirectionText>
        )}
    </StyledHeader>
  )
}
